import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import React, { useState } from "react";
import { Confirm, useTranslate } from "react-admin";
import { useFormState } from "react-final-form";
import { useArrivedPopupContext } from "resources/orders/forms/ArrivedPopupContextManager";
import { isInArray } from "utils/general";

import { useTerminalsContext } from "../../contexts/TerminalsProvider";
import { OrderService, OrderStatus } from "../../entities/";
import SaveButtonEx from "../_extensions/react-admin/ra-ui-materialui/src/button/SaveButtonEx";

const getWarningsIfExist = (values, initialValues, warningValidations, terminals) => {
	const warnings = [];
	for (const [key, validator] of Object.entries(warningValidations)) {
		const warningMsg = validator(values, initialValues, terminals);
		if (warningMsg) warnings.push(warningMsg);
	}
	return warnings ? warnings : null;
};

const translateWarnings = (warnings, translate) => {
	return warnings.map((warning) => translate(warning));
};

export const SaveForceTruckArrivedForOrder = ({ warningValidations, ...props }) => {
	const translate = useTranslate();
	const { open } = useArrivedPopupContext();
	const { values, initialValues, errors } = useFormState();
	const [confirmOpen, setConfirmOpen] = useState(false);
	const [warningsInfo, setWarningsInfo] = useState("");
	const [handleSubmitProps, setHandleSubmitProps] = useState();
	const [showFormDialog, setShowFormDialog] = useState(false);
	const { data: terminals } = useTerminalsContext();
	const [customClickProp, setCustomClickProp] = useState();
	const [saveProps, setSaveProps] = useState();

	const missingEtaArrival = !!values["eta_date"] && !values["is_eta_arrived"];
	const missingEtdArrival = !!values["etd_date"] && !values["is_etd_arrived"];
	const isLoadingReady = values["status"] === OrderStatus.LOADING_READY;
	const isOneInTerminal = values["status"] === OrderStatus.ONE_IN_TERMINAL;

	const isReloadTerminalGroup = isInArray(
		[OrderService.reloadCarTerminalCar, OrderService.crossDock, OrderService.per],
		values["service"]
	);
	const isReloadCarCar = values["service"] === OrderService.reloadCarCar;
	const isIntoPlukkStorage = values["service"] === OrderService.intoPlukkStorage;

	const getArrivalPrefixToRegister = () => {
		if (isIntoPlukkStorage) {
			if (values["etd_date"]) return missingEtdArrival ? "etd" : null;
			return missingEtaArrival ? "eta" : null;
		}
		if (missingEtaArrival) return "eta";
		if (missingEtdArrival) return "etd";
		return null;
	};
	const arrivalPrefixToRegister = getArrivalPrefixToRegister();

	const forceSetVehicleArrivalCondition =
		(((isReloadTerminalGroup || isIntoPlukkStorage) && isLoadingReady) ||
			(isReloadCarCar && (isLoadingReady || isOneInTerminal))) &&
		!!arrivalPrefixToRegister;

	const handleConfirmSave = () => {
		setConfirmOpen(false);
		setCustomClickProp(handleSubmitProps);
	};

	const handleConfirmClose = () => {
		setConfirmOpen(false);
	};

	const saveDialog = () => {
		if (arrivalPrefixToRegister) {
			open(arrivalPrefixToRegister);
		}
		setShowFormDialog(false);
	};

	const closeDialog = () => {
		setShowFormDialog(false);
		showWarnings(saveProps);
	};

	const handleSubmitWithWarnings = (onSaveProps) => {
		setSaveProps(onSaveProps);

		if (forceSetVehicleArrivalCondition) {
			setShowFormDialog(true);
		} else {
			setShowFormDialog(false);
			showWarnings(onSaveProps);
		}
	};

	const showWarnings = (onSaveProps) => {
		if (Object.keys(errors).length) {
			setCustomClickProp(onSaveProps);
			return;
		}
		const warningsContent = getWarningsIfExist(
			values,
			initialValues,
			warningValidations,
			terminals
		);

		if (warningsContent && warningsContent.length) {
			setWarningsInfo(translateWarnings(warningsContent, translate).join("\n"));
			setHandleSubmitProps(onSaveProps);
			setConfirmOpen(true);
		} else {
			setCustomClickProp(onSaveProps);
		}
	};

	return (
		<>
			<SaveButtonEx
				{...props}
				customHandleClick={handleSubmitWithWarnings}
				customClickProp={customClickProp}
			/>

			<Confirm
				isOpen={confirmOpen}
				content={warningsInfo}
				title="osfc.dialogs.order_warnings.title"
				confirm="osfc.dialogs.order_warnings.actions.confirm"
				cancel="osfc.dialogs.order_warnings.actions.cancel"
				onConfirm={handleConfirmSave}
				onClose={handleConfirmClose}
			/>

			<Dialog open={showFormDialog} onClose={() => setShowFormDialog(false)}>
				<DialogTitle>{translate("resources.orders.messages.warn.set-car-arrived")}</DialogTitle>
				<DialogActions>
					<Button onClick={saveDialog} variant="contained" color="primary">
						{translate("resources.orders.buttons.set-car-arrived-button")}
					</Button>

					<Button onClick={closeDialog} variant="contained" color="secondary">
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
